/**
 * Canonical desktop content width for Explore and surfaces that visually align
 * with it. Individual sections add `px-4` for the shared inner gutter.
 */
export const EXPLORE_DESKTOP_CONTENT_WIDTH_CLASS = 'w-[84%] max-w-[1680px]';
